export default __webpack_public_path__ + "static/media/Product-small.271f7189.jpeg";